


















































































































































































































import { Component, Prop, Vue, Watch, Emit, Mixins } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import multiselect from 'vue-multiselect';
import { Mounted } from '../decorators';
import { EventBus, hasElements, TypeEventBus, getDateFormattedAsMoment, getDateAsMoment, dateIsSameOrAfterSecond, dateIsSameToAnother, dateIsAfterAnother, getDiffBetweenDates, addTimeToDate, substractTimeToDate, timeIsValid, addItemToLocalStorage, StoregeKey, removeItemFromLocalStorage, NAME_ROUTES } from '../utils';
import { RootStoreHelper, NotificationStoreHelper } from '../../core/mixins';
import { dateTypes, diffOptions, TypeFilterDate } from '../models';

// Vue.directive('click-outside', {
//   bind: function (el, binding, vnode) {
//     this.event = function (event) {
//       if (!(el == event.target || el.contains(event.target))) {
//         vnode.context[binding.expression](event);
//       }
//     };
//     document.body.addEventListener('click', this.event)
//   },
//   unbind: function (el) {
//     document.body.removeEventListener('click', this.event)
//   },
// });

@Component({
    components: {
        multiselect
    }
})
export default class DateRangeSelector extends Mixins(RootStoreHelper, NotificationStoreHelper) {
    rangeDate: Date[] = [];
    @Prop() visible: boolean;
    @Prop() label: string;
    @Prop() rangeSelected: Date[];
    @Prop({ default: false }) activeButton: boolean;
    @Prop({ default: false }) disabled: boolean;
    dateStart: string = '';
    hourStart: string = '00:00';
    hourEnd: string = '23:59';
    dateEnd: string = '';
    rangeDateStart: string = '';
    rangeDateEnd: string = '';
    rangeSelectedIsValid: any = '';
    menu: boolean = true;
    hoursSelector: any = [];
    showComponent: boolean = false;
    errorEndDate: boolean = false;
    errorHourEndDate: boolean = false;
    showSelectors: boolean = false;
    lastModified: string | null = null;
    maxDaysLimit: number = 7;
    timeoutApply: any = null;
    wasClicked: boolean = false;

    mounted() {
        if (this.$_getFilterDate === TypeFilterDate.RANGE_DATE) {
            if (this.existAnyDateRange) {
                this.showComponent = true;
            }
            if (
                (this.existAnyDateRange && this.rangeSelectedIsValid !== '') ||
                (this.rangeSelectedIsValid && this.$_getQueryParams['hasParams'])
            ) {
                this.showSelectors = false;
            } else {
                this.showSelectors = true;
            }
        }
        EventBus.$on(TypeEventBus.FILTER_CHANGED, payload => {
            this.checkIfRangeDateIsValid();
        });
        EventBus.$on(TypeEventBus.APPLY_RANGE_DATE, payload => {
            this.applyFilter(false);
        });

        EventBus.$on(TypeEventBus.CLOSE_DATERANGE_SELECTOR, payload => {
            setTimeout(() => {
                this.showSelectors = false;
            }, 800);
        });
    }

    focusDateStart() {
        this.closeDatePickers();
        this.handleListenKey(true);
    }

    focusDateEnd() {
        this.closeDatePickers();
        this.handleListenKey(true);
    }

    closeDatePickers() {
        let menuElement1 = this.$refs.rangeDateStart as HTMLFormElement;
        let menuElement2 = this.$refs.rangeDateEnd as HTMLFormElement;
        menuElement1.save(this.dateStart);
        menuElement2.save(this.dateEnd);
    }

    get getSummaryIcon() {
        if (!this.existAnyDateRange) {
            if (this.showSelectors) {
                return 'mdi-arrow-collapse-up';
            } else {
                return 'mdi-calendar';
            }
        } else {
            return 'mdi-close';
        }
    }

    get checkIfAreFieldAreFilled() {
        if (this.dateStart && this.hourStart && this.dateEnd && this.hourEnd) {
            return true;
        }
        return false;
    }

    @Watch('$_getFilterDate')
    watchFilterDate() {
        if (this.$_getFilterDate !== TypeFilterDate.RANGE_DATE) {
            this.showComponent = false;
            this.showSelectors = false;
        } else {
            this.showComponent = true;
            this.showSelectors = false;
        }
    }

    @Watch('$_getIfRangeSelectedIsValid')
    watchrangeSelectedIsValid(value) {
        if (this.$_getFilterDate === TypeFilterDate.RANGE_DATE) {
            if(this.$route.name === 'travel' || this.$route.name === 'journeysList'){
               this.showComponent = true;     
            }
           
            if (!value) {
                this.showSelectors = true;
            } else {
                this.showSelectors = false;
                EventBus.$emit(TypeEventBus.CLOSE_DATEPICKER_POPUP);
            }
        }
    }

    @Watch('activeButton')
    watchActiveButton(value) {
        this.showComponent = value;
    }

    @Watch('showComponent')
    watchComponentVisibility() {
        if (!this.existAnyDateRange || !this.$_getIfRangeSelectedIsValid) {
            this.showSelectors = true;
        } else {
            this.showSelectors = false;
        }
    }


    get existAnyDateRange() {
        if (this.rangeSelected.length > 0) {
            return true;
        }
         return false;
    }

    get getSummaryText() {
        if (this.rangeSelected.length > 0) {
            if (this.rangeSelected[0] && this.dateStart === '') {
                this.setStartDate(this.rangeSelected[0])
            }
            if (this.rangeSelected[1] && this.dateEnd === '') {
                this.setEndDate(this.rangeSelected[1])
            }
            return this.formatTimeStamp(this.rangeSelected[0]) + ' ~ ' + this.formatTimeStamp(this.rangeSelected[1]);
        } 
        return 'Seleccionar rango de fechas';
    }

    setStartDate(value){
        this.dateStart = getDateFormattedAsMoment(value, dateTypes.dateYearFormatReverse)
    }
    setEndDate(value){
        this.dateEnd = getDateFormattedAsMoment(value, dateTypes.dateYearFormatReverse)
    }

    getHourValueParsed(value){
        return getDateFormattedAsMoment(value, dateTypes.hoursAndMinutesFormat)
    }

    @Watch('rangeSelected')
    watchRangeSelected(dateRange) {
        if (dateRange.length > 0) {
            this.setStartDate(dateRange[0]);
            this.setEndDate(dateRange[1]);
            this.hourStart = this.getHourValueParsed(dateRange[0])
            this.hourEnd = this.getHourValueParsed(dateRange[1])
            this.checkIfRangeDateIsValid();
        } else {
            this.clearDate();
        }
    }

    getHourOption(hour, min){
        return getDateFormattedAsMoment({ hour, minute: min }, dateTypes.hoursAndMinutesFormat)
    }

    get getHoursOptions() {
        for (let hour = 0; hour < 24; hour++) {
            this.hoursSelector.push(this.getHourOption(hour, 0));
            this.hoursSelector.push(this.getHourOption(hour, 15));
            this.hoursSelector.push(this.getHourOption(hour, 30));
            this.hoursSelector.push(this.getHourOption(hour, 45));
            this.hoursSelector.push(this.getHourOption(hour, 55));
        }
        return this.hoursSelector;
    }

    @Watch('dateStart')
    observableDateStart(date) {
        this.lastModified = 'dateStart';
    }

    @Watch('dateEnd')
    observableDateEnd(date) {
        this.lastModified = 'dateEnd';
    }

    @Watch('hourEnd')
    watchHourEnd(hour) {
        if (hour === '00:00') {
            this.hourEnd = '23:59';
        }
    }

    clearDate() {
        this.dateStart = '';
        this.dateEnd = '';
        this.hourStart = '00:00';
        this.hourEnd = '23:59';
        this.clearErrors();
    }

    resetFilter() {
        this.clearDate();
        this.clearErrors();
        this.$_setIfRangeSelectedIsValid(false);
        let rangeDate = {
            datetime_from: '',
            datetime_to: ''
        };
        this.showSelectors = true;
        removeItemFromLocalStorage(StoregeKey.FILTERED_DATE_RANGE)
        this.$emit('change-filter-date', TypeFilterDate.RANGE_DATE, rangeDate);
        EventBus.$emit(TypeEventBus.CLEAR_FILTER_DATE);
    }

    clearErrors() {
        this.errorEndDate = false;
        this.errorHourEndDate = false;
    }

    checkIfEndTimeIsValid(){
        let startTime = getDateAsMoment(this.hourStart, dateTypes.hoursAndMinutesFormat)
        let endTime =  getDateAsMoment(this.hourEnd, dateTypes.hoursAndMinutesFormat);

        return dateIsSameToAnother(
                getDateAsMoment(this.dateEnd, dateTypes.dateYearFormatReverse), 
                getDateAsMoment(this.dateStart, dateTypes.dateYearFormatReverse)
            ) && !dateIsAfterAnother(endTime, startTime)
    }

    getDaysOfDifference(dateFrom, dateTo): number{
        if (dateFrom > dateTo) {
            return getDiffBetweenDates(dateTo, dateFrom, diffOptions.days)
        } else {
            return getDiffBetweenDates(dateFrom, dateTo, diffOptions.days)
        }
    }

    checkIfRangeDateIsValid() {
        this.clearErrors();
        this.rangeSelectedIsValid = false;
        if (this.dateStart && this.dateEnd && this.hourStart && this.hourEnd) {
            let dateFrom: Moment | string = getDateAsMoment(this.getStartDate,  dateTypes.globalFilterDateFormat);
            let dateTo: Moment | string =  getDateAsMoment(this.getEndDate,  dateTypes.globalFilterDateFormat);
            let endDateIsValid = dateIsSameOrAfterSecond(getDateAsMoment(this.dateEnd, dateTypes.dateYearFormatReverse), getDateAsMoment(this.dateStart, dateTypes.dateYearFormatReverse))
            let endTimeIsNotValid = this.checkIfEndTimeIsValid();
            //compruebo que la fecha de fin sea la misma o posterior a la inicial

            let daysDifference = this.getDaysOfDifference(dateFrom, dateTo);
            if (this.$route.name === 'travel') {
                if (daysDifference > this.maxDaysLimit) {
                    if (!this.$_getQueryParams['hasParams']) {
                        if (this.lastModified === 'dateStart') {
                            //acorto el rango hasta
                            dateTo = getDateFormattedAsMoment(
                                addTimeToDate(dateFrom, this.maxDaysLimit, diffOptions.days), dateTypes.dateYearFormatReverse
                            )
                            this.dateEnd = dateTo;
                        } else {
                            //acorto el rango desde
                            dateFrom = getDateFormattedAsMoment(
                                substractTimeToDate(dateTo, this.maxDaysLimit, diffOptions.days), dateTypes.dateYearFormatReverse
                            )
                            this.dateStart = dateFrom;
                        }
                        this.rangeSelectedIsValid = true;
                        this.$_setIfRangeSelectedIsValid(true);
                        this.showSelectors = true;
                    } else {
                        this.rangeSelectedIsValid = false;
                        this.$_setIfRangeSelectedIsValid(false);
                        EventBus.$emit(TypeEventBus.NUMBER_OF_DAYS_INVALID);
                        this.$_showHistoricalError(
                            'Sólo pueden ser seleccionados hasta ' + (this.maxDaysLimit + 1) + ' días'
                        );
                        this.errorEndDate = true;
                    }
                } else {
                    this.validDateAndHours(endDateIsValid, endTimeIsNotValid);
                }
            } else {
                this.validDateAndHours(endDateIsValid, endTimeIsNotValid);
            }
        } else {
            this.rangeSelectedIsValid = false;
            this.$_setIfRangeSelectedIsValid(false);
        }
    }

    validDateAndHours(endDateIsValid, endTimeIsNotValid) {
        if (!endDateIsValid) {
            this.$_showHistoricalError('La fecha de fin debe ser posterior o igual a la inicial');
            this.errorEndDate = true;
            this.rangeSelectedIsValid = false;
            this.$_setIfRangeSelectedIsValid(false);
        } else if (endTimeIsNotValid) {
            this.$_showHistoricalError('La hora de fin debe ser posterior a la inicial');
            this.errorHourEndDate = true;
            this.rangeSelectedIsValid = false;
            this.$_setIfRangeSelectedIsValid(false);
        } else {
            this.rangeSelectedIsValid = true;
            this.$_setIfRangeSelectedIsValid(true);
        }
    }

    get shouldDisplayContent() {
        if (!this.existAnyDateRange || !this.$_getIfRangeSelectedIsValid) {
            return true;
        } else {
            return false;
        }
    }

    get getStartDate() {
        return this.dateStart + 'T' + this.hourStart + ':00';
    }

    get getEndDate() {
        return this.dateEnd + 'T' + this.hourEnd + ':00';
    }

    clickApplyFilter(){
        if(this.$route.name === NAME_ROUTES.JOURNEYSLIST.name){
            //prevent spam when search journeys
            this.wasClicked = true;
                this.timeoutApply = setTimeout(() => {
                this.wasClicked = false
            }, 2000)
         }

        this.applyFilter(true)
    }

    beforeDestroy(){
        clearTimeout(this.timeoutApply)
    }

    applyFilter(hideContent) {
        this.checkIfRangeDateIsValid();
        if (this.rangeSelectedIsValid) {
            if (hideContent) {
                this.toggleMenuVisibility();
            }
            this.$_setTypeFilterDate(TypeFilterDate.RANGE_DATE);
            let startDate: any = this.getStartDate;
            let endDate: any = this.getEndDate;
            let datetimeFrom = startDate;
            let datetimeTo = endDate;
            this.saveFilterLocalStorage(startDate, endDate);
            let rangeDate = {
                datetime_from: datetimeFrom,
                datetime_to: datetimeTo
            };
            this.$emit('change-filter-date', TypeFilterDate.RANGE_DATE, rangeDate);
            EventBus.$emit(TypeEventBus.CLOSE_DATEPICKER_POPUP);
        }
    }

    saveFilterLocalStorage(dateA, dateB) {
        addItemToLocalStorage(StoregeKey.FILTERED_DATE_RANGE, {
            datetime_from: dateA,
            datetime_to: dateB
        });
    }

    get color(): string {
        return this.activeButton ? 'green' : '';
    }

    formatTimeStamp(date) {
       return getDateFormattedAsMoment(date, dateTypes.dateFormatFromDisplayInfoNoSeconds)
    }

    formatDate(date) {
        if (date && date !== null) {
            return getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars)
        }
        return null;
    }


    selectStartHour(selectedHour) {
        let validateTime = this.validateTime(selectedHour);
        if (validateTime.isValid()) {
            this.hourStart = selectedHour;
        } else {
            this.hourStart = '';
        }
    }

    selectEndHour(selectedHour) {
        let validateTime = this.validateTime(selectedHour);
        if (validateTime.isValid()) {
            this.hourEnd = selectedHour;
        } else {
            this.hourEnd = '';
        }
    }

    saveStartDate(date, refMenu) {
        if (!this.dateEnd.length) this.dateEnd = date;
        let formattedDate = date ? getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars) : null;
        let menuElement = this.$refs.rangeDateStart as HTMLFormElement;
        menuElement.save(formattedDate);
    }

    saveEndDate(date, refMenu) {
        if (!this.dateStart.length) this.dateStart = date;
        let formattedDate = date ? getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars) : null;
        let menuElement = this.$refs.rangeDateEnd as HTMLFormElement;
        menuElement.save(formattedDate);
    }

    validateTime(time) {
        return timeIsValid(time)
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    clickSummaryIcon() {
        if (this.existAnyDateRange) {
            this.resetFilter();
        } else {
            this.toggleMenuVisibility();
        }
    }

    toggleMenuVisibility() {
        this.showSelectors = !this.showSelectors;
    }

    clickDateButton(item) {
        this.$emit('click-filter-button', item);

        if (this.existAnyDateRange) {
            this.showComponent = true;
            this.showSelectors = false;
            this.applyFilter(false);
        } else {
            this.showComponent = !this.showComponent;
        }
    }
}
